import { fileMixin } from './FileMixin';

export var fileMixinImage = {
    mixins: [fileMixin],
    data: () => ({
        imageData: { path: '', name: '' },
        imageOptional: false,
        imageFiles: [],
        imageTypes: ['.png', '.jpeg', '.jpg'],
        imageValid: true
    }),
    computed: {
        imageRules: function () {
            return [
                value => {
                    let required = !(this.imageOptional || !(!value || (Array.isArray(value) && !value[0])));
                    return required ? 'Fichier requis' : true;
                },
                value => {
                    let extension = value ? this.getExtension(value.name) : '';
                    let allTypes = this.imageTypes.reduce((acc, item) => acc + ' *' + item, '');
                    let required = !(this.imageOptional && extension === '');
                    let extensionValid = !this.imageTypes.includes('.' + extension);
                    return required && extensionValid ? 'Formats attendus:' + allTypes : true;
                },
                value => {
                    let required = !(this.imageOptional && !value);
                    let validSize = !(value && value.size < 4000000);
                    return required && validSize ? 'La taille du fichier doit être inférieur à 4 MB!' : true;
                }
            ];
        }
    },
    watch: {
        imageValid: function (newValue) {
            this.$emit('validate', newValue);
        }
    },
    methods: {
        initImageFiles: function (file, path, optional = false) {
            this.imageOptional = optional;
            if (file && file.path !== '') {
                this.createFile(path + file.path, file.name).then((data) => {
                    this.imageFiles = data;
                    this.imageValid = this.validateImage(this.imageFiles);
                });
            }
        },
        validateImage: function (image) {
            return this.imageRules.reduce((acc, item) => acc && item(image) && typeof item(image) !== 'string', true);
        },
        onChangeImage: function (image) {
            if (!image && this.imageOptional) {
                this.imageData = { path: '', name: '' };
                this.imageValid = true;
                return;
            }
            this.imageValid = this.validateImage(image);
            this.onChangeFile(image, this.imageValid).then((data) => {
                this.imageFiles = data.file;
                this.imageData = data.shortFile;
            }).catch((err, data) => {
                this.$toasted.error(err);
                this.imageData = data;
            });
        }
    }
};
